import React, { useEffect, useState } from 'react';
import { colourString, getUserInitials } from '../../../library/helpers';
import { ProfilePlaceholderIcon } from './avatar-icon.placeholder';
import styles from './avatar-icon.module.css';
import classNames from 'classnames';
export function AvatarIcon(_a) {
    var _b;
    var _c = _a.backgroundColour, backgroundColour = _c === void 0 ? 'primary' : _c, _d = _a.fontColour, fontColour = _d === void 0 ? 'contrast-text' : _d, imageUrl = _a.imageUrl, name = _a.name;
    var _e = useState(['', '']), initials = _e[0], setInitials = _e[1];
    useEffect(function () {
        if (!!name) {
            var _a = name.firstName, firstName = _a === void 0 ? '' : _a, preferredName = name.preferredName, _b = name.lastName, lastName = _b === void 0 ? '' : _b;
            setInitials(getUserInitials(preferredName !== null && preferredName !== void 0 ? preferredName : firstName, lastName));
        }
    }, [name]);
    if (!!imageUrl) {
        return (React.createElement("div", { className: classNames(styles.avatarIconWrapper, "kplr_avatarIconWrapper") },
            React.createElement("div", { className: styles.avatarIconInner },
                React.createElement("img", { src: imageUrl, alt: (_b = name === null || name === void 0 ? void 0 : name.firstName) !== null && _b !== void 0 ? _b : 'Current User' }))));
    }
    else if (!!initials[0]) {
        return (React.createElement("div", { className: classNames(styles.avatarIconWrapper, "kplr_avatarIconWrapper") },
            React.createElement("div", { className: styles.avatarIconInner },
                React.createElement("div", { className: styles.iconLetters, style: { background: colourString(backgroundColour !== null && backgroundColour !== void 0 ? backgroundColour : 'primary') } },
                    React.createElement("svg", { viewBox: "0 0 20 20", fill: colourString(backgroundColour) },
                        React.createElement("text", { x: "10", y: "11", fill: colourString(fontColour), textAnchor: "middle", dominantBaseline: "middle", fontSize: "12" }, initials[0]))))));
    }
    else {
        return (React.createElement("div", { className: classNames(styles.avatarIconWrapper, "kplr_avatarIconWrapper") },
            React.createElement("div", { className: styles.avatarIconInner },
                React.createElement(ProfilePlaceholderIcon, null))));
    }
}
export default AvatarIcon;
